"use strict";

var G = require('@antv/g/lib');

module.exports = G;


//////////////////
// WEBPACK FOOTER
// ./src/renderer.js
// module id = 18
// module chunks = 0 1 2